var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 8V5.33333C11.3333 4.59695 10.7364 4 10 4H3.33333C2.59695 4 2 4.59695 2 5.33333V10.6667C2 11.4031 2.59695 12 3.33333 12H10C10.7364 12 11.3333 11.4031 11.3333 10.6667V8ZM11.3333 8L14 5.33333V10.6667L11.3333 8Z",
    stroke: "#282D38",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOn);
export default __webpack_public_path__ + "static/media/video_on.973ce19887ba8fc069f752cc12d13aec.svg";
export { ForwardRef as ReactComponent };